import {enableNaverPoint} from '@web/actions/pointPayment'
import {selectPayMethod} from '@web/actions/priorityPaymentMethod'
import {restoreOrderSheetDataByStorage} from '@web/actions/restoreState'
import makeSlice from '@web/slices/pointPayment/sliceMaker'

import {initPaymentMethodManagement} from '../../actions'

import {getPreferredPoint} from './utils'

const slice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(restoreOrderSheetDataByStorage.fulfilled, (state, {payload}) => {
                state.naverPayPoint.usePointAll =
                    payload.pointPayment?.naverPayPoint.usePointAll ?? state.naverPayPoint.usePointAll
            })
            .addCase(initPaymentMethodManagement.fulfilled, (state, {payload: {response}}) => {
                const {
                    prevPaymentMethodInfo: {usePointAll, recentPayInfo},
                } = response

                state.naverPayPoint.usePointAll = !!usePointAll

                state.naverPayPoint.preferredPoint = getPreferredPoint(recentPayInfo?.preferredPoint)
            })
            .addCase(enableNaverPoint.fulfilled, (state) => {
                state.naverPayPoint.usePointAll = !state.naverPayPoint.usePointAll
            })
            .addCase(selectPayMethod, (state, {payload: {shouldUsePointAll}}) => {
                /** 전액사용 on 해야하는 경우 On으로 세팅 */
                if (shouldUsePointAll) {
                    state.naverPayPoint.usePointAll = true
                }
            })
    },
})

export default slice.reducer
